import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { WCupRankingBootstrapComponent } from './components/wcup-ranking-bootstrap/wcup-ranking-bootstrap.component';
import { WCupRankingFiltersComponent } from './components/wcup-ranking-filters/wcup-ranking-filters.component';
import { WCupRannkingDetailComponent } from './components/wcup-rannking-detail/wcup-rannking-detail.component';
import { WCupRannkingItemComponent } from './components/wcup-rannking-item/wcup-rannking-item.component';
import { WCupRannkingListComponent } from './components/wcup-rannking-list/wcup-rannking-list.component';
import { FilterWCupRankingService } from './services/filter-wcup-ranking.service';
import { WCupRankingRoutingModule } from './wcup-ranking-routing.module';
import { WcupSeriesPanelComponent } from './components/wcup-series-panel/wcup-series-panel.component';
import { CommonPageComponentsModule } from '../../common-page-components/common-page-components.module';
import { CoreModule } from '../../library/core.module';
import { ServicesModule } from 'world-archery-lib';

@NgModule({
  bootstrap: [WCupRankingBootstrapComponent],
  imports: [CommonModule, ServicesModule, WCupRankingRoutingModule, CoreModule, CommonPageComponentsModule],
  declarations: [
    WCupRankingBootstrapComponent,
    WCupRankingFiltersComponent,
    WCupRannkingListComponent,
    WCupRannkingItemComponent,
    WCupRannkingDetailComponent,
    WcupSeriesPanelComponent
  ],
  providers: [FilterWCupRankingService]
})
export class WCupRankingModule { }
